module.exports = __webpack_public_path__ + "img/52.3bc3bd88.webp";